// @flow
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';

import { tokenize } from '../tokenize';

export function getTokenizationFunction(incomingPayment: IncomingPayment): Function {
  if (incomingPayment.status !== 'OP') {
    throw new Error(`Opened Payment: Payment status should be OP. Currently is ${incomingPayment.status}`);
  }

  return tokenize;
}
